<script>
export default {
    name: 'IconScooling',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-scooling"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M52 24v5a5 5 0 00-5 5v6a5 5 0 005 5v3l-20 8-20-8v-3a5 5 0 005-5v-6a5 5 0 00-5-5v-5l20 8 20-8zm-40 8a3 3 0 013 3v4a3 3 0 01-6 0v-4a3 3 0 013-3zm40 0a3 3 0 013 3v4a3 3 0 01-6 0v-4a3 3 0 013-3zM32 8a8 8 0 110 16 8 8 0 010-16z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
